import React from 'react';
import { DialogContentText } from '@mui/material';
import ConfirmationDialog from './ConfirmationDialog';

const VerificationPauseRescueConfirmationDialog = ({
  onCloseDialog,
  onPauseButtonClick,
  isSD = false,
  siteName = null,
}) => (
  <ConfirmationDialog
    dialogProps={{
      fullWidth: true,
    }}
    title="Pause rescuing"
    customMessage={
      isSD ? (
        <>
          <DialogContentText>
            Are you sure you want to pause rescuing for this user{siteName ? ` at ${siteName}` : ''}?
          </DialogContentText>
          <DialogContentText>
            Pausing it will unclaim this user&apos;s currently claimed rescues at this site only. The user&apos;s
            notification preferences are not changed.
          </DialogContentText>
        </>
      )
      : (
        <>
          <DialogContentText>Are you sure you want to pause rescuing?</DialogContentText>
          <DialogContentText>
            Pausing it will pause you at all of your sites and unclaim all your currently claimed rescues.
          </DialogContentText>
        </>
      )
    }
    closeDialog={onCloseDialog}
    buttons={[
      { variant: 'outlined', label: 'Cancel', color: 'primary', onClick: onCloseDialog },
      { variant: 'contained', label: 'Pause rescuing', color: 'primary', onClick: onPauseButtonClick },
    ]}
  />
);

export default VerificationPauseRescueConfirmationDialog;
